import React from 'react';

import './Breadcrumbs.scss';
import { Props } from './interfaces';
import { EnumUrlsPages } from '../../services/Enum';
import { SchemaJsonBreadcrumbList } from './Functions';
import {content} from "../../services/content";
import {Link} from "../Link/Link";

const BreadcrumbsCustom = ({ title = '' }: Props) => {
  return (
    <div className="breadcrumbs">
      <SchemaJsonBreadcrumbList title={title} section="services" />

      <span className="breadcrumbs__item">
        <Link className="breadcrumbs__link" to="/">
          <span>{content.breadcrumbsCustom.main}</span>
        </Link>
      </span>
      <span className="breadcrumbs__item">
        <Link className="breadcrumbs__link" to={EnumUrlsPages.delivery}>
          <span>{content.breadcrumbsCustom.services}</span>
        </Link>
      </span>
      <span className="breadcrumbs__item">
        <a className="breadcrumbs__link" href="/">
          <span>{title}</span>
        </a>
      </span>
    </div>
  );
};

export default BreadcrumbsCustom;
